import { Component, Inject, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import { MatSnackBar } from '@angular/material/snack-bar';

import { BookingCommonComponent } from 'src/modules/booking-portal/booking-common.component';

import { FacilitySummary } from 'src/modules/models/asset/facility-summary';
import { AssetService } from 'src/modules/services/asset.service';
import { Utility } from 'src/modules/utility';
import { Store, ICart, AddFacility, UpdateFacility, EditFacility, DeleteFacilityPrice, UpdateBookingPackage } from 'src/modules/store/index';

import { Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";

import { MomentDateAdapter } from 'src/modules/booking-portal/common/date-time-adapter/moment-date-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { FacilityAdaptor } from 'src/modules/models/asset/facility-adaptor';
import { BookingAdaptor } from 'src/modules/models/booking/booking-adaptor';
import { CalenderTimeslot, Timeslot } from 'src/modules/models/asset/timeslots';
import { environment } from 'src/environments/environment';
import { Booking } from 'src/modules/models/booking/booking';
import { ItemService } from 'src/modules/services/item.service';
import { AlternativeOptionsComponent } from 'src/modules/booking-portal/booking-cart/edit-modal/alternative-options/alternative-options.component';
import { DateFormat } from 'src/modules/date-format';
import { Item, UpsellSummary } from 'src/modules/models/item/item';
import { Configuration } from 'src/modules/models/asset/configuration';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { ItemPriceGroup } from 'src/modules/models/item/item-price-group';
import { AppSetting } from 'src/modules/models/settings/casual-portal/app-setting';
import { WarningMessageComponent } from 'src/modules/shared/warning-message/warning-message.component';
import { Action, ErrorType } from 'src/modules/models/enum';
import { UserDefinedFunction } from 'src/modules/models/system/user-defined-function';
import { PackageFilter } from 'src/modules/models/booking/common';
import { BespokePackage } from 'src/modules/models/asset/bespoke-package';
import { DeleteConfirmationComponent } from 'src/modules/shared/delete-confirmation/delete-confirmation.component';
import { AlertMessageComponent } from 'src/modules/shared/alert-message/alert-message.component';
import { QuestionnaireComponent } from '../../modals/questionnaire/questionnaire.component';
import { PackageQuestionPopupHidden, PackageQuestionPopupShown } from 'src/modules/store/actions';
import { PackageService } from 'src/modules/services/package.service';
import { SuccessMessageComponent } from 'src/modules/shared/success-message/success-message.component';
import { FormControl } from '@angular/forms';
import { take } from 'rxjs/operators';
import * as _ from 'lodash';
import { BookingService } from '../../../services/booking.service';
import {FacilitySearchLoaded, FacilitySearchLoading, ILoadingStatus} from '../../../store/loading';
const moment = _rollupMoment || _moment;



export const MY_FORMATS = {
  parse: { dateInput: 'LL' },
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'opt-edit-modal',
  templateUrl: './edit-modal.component.html',
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class EditModalComponent extends BookingCommonComponent implements OnInit, OnDestroy {
  imagepath: string = environment.ApiUrl + environment.publishFolder;

  date = moment();
  facilitySummary: FacilitySummary;
  booking = new Booking;
  startTime: Date;
  endTime: Date;

  selected = 'option1';

  //select-configuration
  configurationDisplayMode: any;
  isConfigurationEnabled: boolean;
  isCategoryAndEventEnabled: boolean;
  isCategoryAndEventMandatory: boolean;
  // time picker validation
  minDate: Date = new Date();
  maxDate: Date;
  minStartDate: Date;
  maxStartDate: Date;
  minEndDate: Date;
  maxEndDate: Date;
  isValidStart: boolean;
  isValidEnd: boolean;

  attendees: number;
  isAvailable: boolean = false;
  showUnavailableMessage: boolean = false;
  isAddFacility = false;
  //timeWithBumpIn: Date;
  //timeWithBumpOut: Date;
  isCheckAvailabilityTriggered: boolean = false;
  showUnavailableFutureDateMessage: boolean = false;
  IsDateChangeFromCalendar: boolean = true;
  showUnavailableFutureDateErrorMessage: string;
  showUnavailableOperationalMessage: boolean = false;
  selectedPackageClass: any;
  selectedClass: number;
  showBookingLeadDayValidationMessage: boolean = false;
  showBookingPackageLevelLeadDayValidationMessage: boolean = false;
  bookingLeadDayValidationMessage: any;
  bookingPackageLevelLeadDayValidationMessage: any;
  isBookingAdded: boolean = false;
  isBookingLeadDaysError: boolean = false;

  displayBumpInOutNotification: boolean;

  timeLineColors: any;
  isSystemAllowedImmediateConfirmation: boolean;
  systemDefaultPriceConsessionId: number;

  facilitySummaries: FacilitySummary[] = [];

  availableSlots: CalenderTimeslot[] = [];
  panelOpenState: boolean;
  isEnableAutoAvailabilityCheck: boolean = false;
  @ViewChild('hoverStartMenuTrigger') starttrigger: MatMenuTrigger;
  @ViewChild('hoverEndMenuTrigger') endtrigger: MatMenuTrigger;
  isEnableTimeLineAdvancedMode: boolean;
  startChangedByTimeslotClick: number = 0;
  endChangedByTimeslotClick: number = 0;

  errorMessages: string[] = [];
  warningMessages: string[] = [];

  cartData: ICart;

  AppData: AppSetting;

  continueProcess: boolean;

  packageFilter: PackageFilter;
  selectedPackage: string;
  selectedPackageDetail: BespokePackage;
  defaultEventName: string;
  packageClasses: any[] = [];
  selectedBusinessArea: string
  packages: BespokePackage[] = [];
  packageDetail: BespokePackage;
  isValidPackage: boolean;
  packageSelected: BespokePackage;
  isContinueProcessOnpackageChange: boolean = true;
  isContinueProcessOnTimeChange: boolean = true;
  isStartTimeChanged: boolean;
  isShowQuestionsUpdate: boolean = false;

  attendeesSubs: Subscription;
  attendessControl = new FormControl();
  timechange: boolean = false;
  itemUnavailableMessages: string;
  hasDiaryNote : boolean = false;
  isFacilityClosed : boolean = false;

  loading : boolean = false;
  availableSlotsLoading : boolean = false;
  activeRequests = 0;
  customFunctionActiveRequests = 0;
  cartPackageCustomFunctionActiveRequests = 0;
  constructor(
    public dialogRef: MatDialogRef<EditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private _assetService: AssetService,
    private _itemService: ItemService,
    private _packageService: PackageService,
    private _bookingService: BookingService,
    private store: Store<any>,
    private cdr: ChangeDetectorRef,
    public snackBar: MatSnackBar

  ) {
    super(store, _itemService, snackBar);
    this.AppData = environment.AppSetting as AppSetting;
    this.maxDate = new Date(environment.LatestFutureBookingDate);

    this.timeLineColors = environment.CheckAvailability.TimeLineColors

    this.facilitySummary = data.facility;
    this.selectedPackageClass = data.selectedPackageClass;
    this.panelOpenState = this.AppData.BookingConfig.IsDefaultExpandAlternativeConfigurationForFacility;


    if (this.facilitySummary) {
      this.facilitySummary.timeslotLoaded = false;
      this.startTime = Utility.convertISOToDate(this.facilitySummary.startTime);
      this.endTime = Utility.convertISOToDate(this.facilitySummary.endTime);
      this.attendees = this.facilitySummary.attendees;

      this.displayBumpInOutNotification = environment.ConfigurationSelection.DisplayBumpInOutNotification;
      this.date = moment(this.facilitySummary.startTime);
    }


    this.booking = new Booking();
    if (data.isaddfacility != undefined || data.isaddfacility != null) {
      this.isAddFacility = data.isaddfacility;
    }

    this.isSystemAllowedImmediateConfirmation = environment.ImmediateConfirmation.Allow;
    this.systemDefaultPriceConsessionId = environment.ImmediateConfirmation.DefaultPriceConsessionId;

    this.initializeTime();
    this.checkAvailability();

    this.AppData = environment.AppSetting as AppSetting;

    this.attendeesSubs = this.attendessControl.valueChanges
      .debounceTime(1500)
      .subscribe(e => {
        let itm = this.getItem();// (this.facilitySummary.selectedItem ? this.facilitySummary.selectedItem : this.facilitySummary.item);

        // onchanging number of attendees if price typee cover
        if ((itm.itemMinPrice && itm.itemMinPrice.priceType.toLowerCase() == "covers") || (itm.itemMaxPrice && itm.itemMaxPrice.priceType.toLowerCase() == "covers")) {
          this.facilitySummary.attendees = this.attendees;
          this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime), false, false);
        }
      });


  }
  filteredPackages: BespokePackage[] = [];
  remainingLeadDaysList: { id: string, remainingLeadDays: number }[] = [];
  remainingPackageLeadDaysList: { id: string, remainingLeadDays: number }[] = [];
  hasExecuted: boolean = false;
  facilityOpeningTime: string

  facilityClosingTime: string

  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }

  ngOnInit() {
    super.ngOnInit();
    this.validateAvailability();
    this.hasExecuted = false;
    this.cart$.safeSubscribe(this, state => {
      this.booking = state.booking;
      this.facilitySummaries = state.addedFacilites;
      this.cartData = state as ICart;

      this.packages = state.bespokePackages;
      if (state.packageFilter != undefined && state.packageFilter != null) {
        this.packageFilter = state.packageFilter;
        if (state.packageFilter?.Package) {
          if (this.selectedPackage == null) {
            this.selectedPackage = state.packageFilter.Package.toString();
            this.CallPackageChangeValidation();
          }
          this.selectedPackageDetail = state.packageFilter.PackageDetail;
          console.log("state.packageFilter.PackageDetail", state.packageFilter.PackageDetail);
        }
        this.defaultEventName = state.packageFilter.EventName;
        if (state != undefined && state.packageFilter != undefined && state.packageFilter != null) {
          this.packageClasses = state.packageFilter.FilteredPackageClasses;
          //this.selectedPackageClass = this.packageClasses.find(a => a.Id == state.packageFilter.PackageClass);
        }
        this.packageDetail = state.packageFilter?.PackageDetail;
      }




      if ((!state.addedFacilites) || (state.addedFacilites && state.addedFacilites.length == 0)) {
        this.validatePackageClass(state);
      }

      if (this.filteredPackages.length == 0) {
        this.filteredPackages = this.selectPackageList();
      } else {
        // This handles cases where packages exist but none are selected
        if (!this.selectedPackage && this.filteredPackages.length == 1) {
          this.selectedPackage = this.filteredPackages[0].id;
          this.packageSelectorChange(this.filteredPackages[0]);
          this.questionValidation();
        }
      }

      if (!this.hasExecuted) {
        this.hasExecuted = true;
        var leadDays = this.getLeadDays(this.selectedPackage != "" ? this.selectedPackage : "");
        this.setLeadDaysIntoCalander(leadDays, true)

        this.setItemRemainingLeadDaysList(this.startTime, this.facilitySummary.items)
        this.setPackageRemainingLeadDaysList(this.startTime, this.packages)
        this.showPackageLevelLeadDaywarnigMessage(this.selectedPackage);
      }

    });
    this.configurationDisplayMode = environment.ConfigurationSelection.DisplayMode;
    this.isConfigurationEnabled = environment.ConfigurationSelection.Enabled;
    this.isEnableAutoAvailabilityCheck = environment.CheckAvailability.EnableAutoAvailabilityCheck;

    this.isCategoryAndEventEnabled = this.AppData.AddEditPopupPageSettings.EnableCategoryAndEventSelection;
    this.isCategoryAndEventMandatory = this.AppData.AddEditPopupPageSettings.MandatoryCategoryAndEventSelection;

    if (this.isConfigurationEnabled) this.getImagesforConfigurations();
    this.isEnableTimeLineAdvancedMode = environment.CheckAvailability.EnableTimeLineAdvancedMode;

    this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime));
  }

  //ngOnDestroy() {
  //    if (this.cart_subscriber)
  //        this.cart_subscriber.unsubscribe();
  //}

  public close() {
    this.dialogRef.close(this.facilitySummary);
  }

  async add(val) {
    this.attendees = ((this.attendees + val) <= 0) ? 0 : this.attendees + val;
  }

  async refreshBooking(facility: FacilitySummary) {
    var thisPage = this;


    if (this.isBookable()) {

      let _validationOutPut;

      if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
        let exsitingfacilitySummaries = (this.cartData.addedFacilites ?? [])
          .filter(f => f !== facility);
        _validationOutPut = await this.CallCustomFunction(facility, Action.OnUpdateBookingItem, this.getPackageDetail(), exsitingfacilitySummaries)
      }
      if (!_validationOutPut || (_validationOutPut && _validationOutPut.ContinueProcess)) {
        facility.attendees = this.attendees;
        facility.startTime = this.getFormattedDate(this.startTime);
        facility.endTime = this.getFormattedDate(this.endTime);

        if (this.facilitySummary.selectedItem != undefined) {
          FacilityAdaptor.changeFacilityItem(this.facilitySummary, this.facilitySummary.selectedItem, this.facilitySummary.selectedConfiguration);
        } else if (this.facilitySummary.selectedConfiguration) {
          this.facilitySummary.configuration = this.facilitySummary.selectedConfiguration;
        }


        this.store.dispatch(new DeleteFacilityPrice(facility));
        if (environment.PriceDisplayOption == 3) {
          //     FacilityAdaptor.populateItemPrice(facility, this.selectedClass);
        }


        this.store.dispatch(new EditFacility(facility));

        this.calculateItemPrices([facility], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime));

        for (const fc of this.facilitySummaries) {
          if (fc.upsellSummaries != undefined && fc.upsellSummaries.length > 0) {
            let time = 0;
            fc.upsellSummaries.forEach(function (us) {
              if (us.minPrice == undefined || us.maxPrice == undefined || (us.minPrice.priceTypeId != 5 && us.minPrice.priceTypeId != 7 && us.maxPrice.priceTypeId != 5 && us.maxPrice.priceTypeId != 7)) {
                time = time + 150;
                setTimeout(function () {
                  thisPage.calculateUpsellItemPrice(us, fc, us.isCleaningFeeItem ? us.startTime : facility.startTime, us.isCleaningFeeItem ? us.endTime : facility.endTime);
                }, time);
              }
            });
          }
        }



        this.updateQuestionPopupState();

        this.dialogRef.close(facility);


      }
    }
  }

  calculateUpsellItemPrice(upsell: UpsellSummary, fc: FacilitySummary, startTime, endTime) {
    var thisPage = this;
    if (this.selectedPackageClass == undefined) return;

    upsell.minPrice = undefined;
    upsell.maxPrice = undefined;
    upsell.startTime = Utility.convertToISO(Utility.convertISOToDate(startTime));
    upsell.endTime = Utility.convertToISO(Utility.convertISOToDate(endTime));

    let packageClassId = (this.selectedPackageClass && !isNaN(this.selectedPackageClass)) ? this.selectedPackageClass : environment.DefaultPackageClassId;
    let concessionsId = FacilityAdaptor.getBookingPriceConcession(this.customerDefaultPriceConsessionId, this.isAllImmediateConfirmed);

    let res = FacilityAdaptor.getMinMaxPriceConcessionForUpsell(concessionsId, packageClassId);
    let minConcessionsId = res.minPriceConcession;
    let maxConcessionsId = res.maxPriceConcession;

    // for min price
    let count = 0
    this._itemService.CalculateItemPrice(upsell.id, minConcessionsId, ((upsell.isSystemGenerated && (upsell.priceTypeId == 7 || upsell.priceTypeId == 10)) ? (fc.attendees ?? upsell.qty) : upsell.qty), upsell.startTime, upsell.endTime)
      .subscribe((result) => {
        if (result.calculatedItemPriceGroups != undefined && result.calculatedItemPriceGroups.length > 0) {
          result.calculatedItemPriceGroups.forEach((cip, i) => {
            if (!(cip instanceof Array)) {
              if (cip.priceIncludingTax != 0)
                upsell.minPrice = cip;
            }
          });
        }

        count++;
        if (count == 2) thisPage.setUpsellPrices(upsell);
      },
        err => {
          console.log("Error : calculateUpsellItemPrice - min  " + upsell.name, err);
          count++;
          if (count == 2) thisPage.setUpsellPrices(upsell);
        }
      );

    // for max price
    setTimeout(function () {
      thisPage._itemService.CalculateItemPrice(upsell.id, maxConcessionsId, ((upsell.isSystemGenerated && (upsell.priceTypeId == 7 || upsell.priceTypeId == 10)) ? (fc.attendees ?? upsell.qty) : upsell.qty), upsell.startTime, upsell.endTime)
        .subscribe((result) => {
          if (result.calculatedItemPriceGroups != undefined && result.calculatedItemPriceGroups.length > 0) {
            result.calculatedItemPriceGroups.forEach((cip, i) => {
              if (!(cip instanceof Array)) {
                if (cip.priceIncludingTax != 0)
                  upsell.maxPrice = cip;
              }
            });
          }

          count++;
          if (count == 2) thisPage.setUpsellPrices(upsell);
        },
          err => {
            console.log("Error : calculateUpsellItemPrice - max  " + upsell.name, err);
            count++;
            if (count == 2) thisPage.setUpsellPrices(upsell);
          }
        );
    }, 80);
  }

  setUpsellPrices(upsell: UpsellSummary) {
    upsell.minPrice = (upsell.minPrice == undefined || upsell.minPrice == null) ? upsell.maxPrice : upsell.minPrice;
    upsell.maxPrice = (upsell.maxPrice == undefined || upsell.maxPrice == null) ? upsell.minPrice : upsell.maxPrice;
    this.store.dispatch(new UpdateFacility(this.facilitySummary));
  }

  checkAvailability() {
    var current = moment().startOf('day');
    this.showBookingLeadDayValidationMessage = false;
    this.showBookingPackageLevelLeadDayValidationMessage = false;
    this.showUnavailableFutureDateMessage = false;
    this.showUnavailableOperationalMessage = false;
    this.availableSlotsLoading = true;

    var selectedDate = this.date.toDate();
    selectedDate.setHours(0, 0, 0, 0);
    var futureDate = new Date(environment.LatestFutureBookingDate);
    futureDate.setHours(0, 0, 0);
    this.isFacilityClosed = FacilityAdaptor.isFacilityClosed(this.facilitySummary, selectedDate);
    if (selectedDate > futureDate) {
      this.showUnavailableFutureDateMessage = true;
      this.showUnavailableFutureDateErrorMessage = environment.LatestFutureBookingDateErrorMessage.replace("#FacilityName#", this.facilitySummary.name);
      this.showUnavailableFutureDateErrorMessage = this.showUnavailableFutureDateErrorMessage.replace("#LatestFutureBookingDate#", moment(environment.LatestFutureBookingDate).format(environment.DateFormat.toUpperCase()).toString());
      this.isAvailable = false;
      this.availableSlotsLoading = false;
      return;
    }
    var currentDate = new Date();
    var daysCount = this.date.diff(currentDate, 'days');
    var leadDays = this.getLeadDays(this.selectedPackage != "" ? this.selectedPackage : "");
    this.setLeadDaysIntoCalander(leadDays)
    this.setItemRemainingLeadDaysList(this.startTime, this.facilitySummary.items)
    this.filteredPackages = this.selectPackageList();
    this.isBookingLeadDaysError = false;
    if (!this.checkRemainingLeadDaysCount(
      (this.facilitySummary?.selectedItem != undefined ? this.facilitySummary?.selectedItem?.id : this.facilitySummary?.item?.id) ?? null, null)) {
      this.bookingLeadDayValidationMessage = (environment?.BookingLeadDayValidationMessage ?? "").replace("#LeadDays#", leadDays.toString());
      this.showBookingLeadDayValidationMessage = true;
      this.isAvailable = false;
      this.isBookingLeadDaysError = true;
      this.showBookingPackageLevelLeadDayValidationMessage = false;
      this.availableSlotsLoading = false;
      return
    }

    this.showPackageLevelLeadDaywarnigMessage(this.selectedPackage ?? "")

    if (this.isValidStart && this.isValidEnd) {
      this.isCheckAvailabilityTriggered = true;
      this.validateAvailability();
    }

    if (this.isEnableAutoAvailabilityCheck) {
      this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime),false ,true);
    }
  }

  getStartEndTime() {
    //let startTime = this.getFormattedDate(this.startTime);
    //let endTime = this.getFormattedDate(this.endTime);
    let timeWithBumpIn = new Date(this.startTime);
    let timeWithBumpOut = new Date(this.endTime);
    var cnf = this.getSelectedConfiguration();
    if (cnf) {
      if (cnf.setupTime && cnf.setupTime > 0) {
        timeWithBumpIn.setMinutes(timeWithBumpIn.getMinutes() - cnf.setupTime)
        //startTime = this.getFormattedDate(timeWithBumpIn);
      }
      if (cnf.teardownTime && cnf.teardownTime > 0 && !cnf.isSystemOverride) {
        timeWithBumpOut.setMinutes(timeWithBumpOut.getMinutes() + cnf.teardownTime)
        // endTime = this.getFormattedDate(timeWithBumpOut);
        //15181
        let maxEndTime = new Date(this.endTime);
        maxEndTime.setHours(24, 0, 0)
        if (Utility.convertToISO(timeWithBumpOut) == Utility.convertToISO(maxEndTime)) {
          timeWithBumpOut = new Date((new Date(this.endTime)).setHours(23, 59, 0, 0))
        }
      }
    }
    return { start: timeWithBumpIn, end: timeWithBumpOut }
  }

  async validateAvailability() {
    if (this.showUnavailableOperationalMessage) {
      return;
    }
    if (this.facilitySummary.facilityTypeId && environment.BookingRestrictions && environment.BookingRestrictions.length > 0) {
      var FCMaxtime = environment.BookingRestrictions.find(ftm => ftm.Id == this.facilitySummary.facilityTypeId)
      if (FCMaxtime && FCMaxtime.MaxNoOfBookingMinutes) {
        var diff = (new Date(this.endTime).getTime() - new Date(this.startTime).getTime()) / 1000;
        diff /= 60;
        let totalBookingMins = Math.abs(Math.round(diff));
        if (totalBookingMins > FCMaxtime.MaxNoOfBookingMinutes) {
          this.showUnavailableFutureDateMessage = true;
          this.showUnavailableFutureDateErrorMessage = "You may book this venue for max " + (FCMaxtime.MaxNoOfBookingMinutes % 60 == 0 ? ((FCMaxtime.MaxNoOfBookingMinutes / 60) + " hours") : (FCMaxtime.MaxNoOfBookingMinutes + " minutes")) + ". Please adjust the duration of the booking to proceed. "
          this.isAvailable = false;
          this.availableSlotsLoading = false;
          return;
        }

      }

    }

    // let fcArr = [];
    // fcArr.push(this.facilitySummary);

    if (this.facilitySummary) {
      let startEndTime = this.getStartEndTime();
      let startTime = this.getFormattedDate(startEndTime.start);
      let endTime = this.getFormattedDate(startEndTime.end);
      var isBookingForNonOperationalHours = this.validateNonOperationalHours(startEndTime.start, startEndTime.end);

      let _cn = this.getSelectedConfiguration();
      if (_cn) {
        if (_cn.isSystemOverride) {
          if(_cn.teardownTime && _cn.teardownTime > 0){
            endTime = Utility.convertToISO(new Date(new Date(endTime).getTime() + _cn.teardownTime * 60000));
          }
        }
      }
      if (!isBookingForNonOperationalHours) {
        this.activeRequests++;
        let availablityResult = this._assetService.timeslotSearch(this.facilitySummary.id, startTime, endTime);
        availablityResult.subscribe(res => {
          if (environment.CheckAvailability.DisplayPreliminarySlotAsUnavailble || res.length < 1 || res == undefined) {
            this.isAvailable = (res.length < 1);
            this.showUnavailableMessage = !(res.length < 1);
          } else {
            var bookedSlot = res.filter(re => re.preliminary == false || re.preliminary === undefined);
            this.isAvailable = !(bookedSlot && bookedSlot.length > 0)
            this.showUnavailableMessage = (bookedSlot && bookedSlot.length > 0);
          }
        },
          err => {
            console.log("Error", err);
            this.isAvailable = false;
            this.showUnavailableMessage = true;
            this.availableSlotsLoading = false;
          },
          () => {
            this.activeRequests--;
            if (this.activeRequests <= 0) {
              this.availableSlotsLoading = false;
            }
          }
        );
      }else {
        this.availableSlotsLoading = false;
      }


      // if (this.IsDateChangeFromCalendar) {
      //     let dayStart = new Date(startTime);
      //     dayStart.setHours(0);
      //     dayStart.setMinutes(0);
      //     dayStart.setSeconds(0);

      //     let dayEnd = new Date(startTime);
      //     dayEnd.setHours(23);
      //     dayEnd.setMinutes(59);
      //     dayEnd.setSeconds(0);

      //     let availablityTimeSlotResult = this._assetService.timeslotSearch(this.facilitySummary.id, this.getFormattedDate(dayStart), this.getFormattedDate(dayEnd));
      //     availablityTimeSlotResult.subscribe(async res => {
      //         this.facilitySummary.availableTimeslots = [];
      //         this.facilitySummary.calenderTimeslots = [];
      //         this.facilitySummary.timeslotLoaded = false;
      //         //validate on date change

      // res.forEach(t => {
      //     if (t.asset.id) {
      //         var facility = fcArr.find(f => f.id == t.asset.id);
      //         if (facility) {
      //             if (!facility.calenderTimeslots) facility.calenderTimeslots = [];
      //             facility.timeslotLoaded = true;
      //             var arr: Timeslot[] = [];
      //             arr.push(t);
      //             var ts = FacilityAdaptor.populateTimeslot(arr, this.date.toDate(), facility);
      //             if (ts) {
      //                 ts.forEach(x => {
      //                     facility.calenderTimeslots.push(x);
      //                 });
      //             }
      //         }
      //     }
      // });

      //             res.forEach(t => {
      //                 if (t.asset.id) {
      //                     var facility = fcArr.find(f => f.id == t.asset.id);
      //                     if (facility) {
      //                         if (!facility.calenderTimeslots) facility.calenderTimeslots = [];
      //                         facility.timeslotLoaded = true;
      //                         var arr: Timeslot[] = [];
      //                         arr.push(t);
      //                         var ts = FacilityAdaptor.populateTimeslot(arr, this.date.toDate(),facility);
      //                         if (ts) {
      //                             ts.forEach(x => {
      //                                 facility.calenderTimeslots.push(x);
      //                              });
      //                         }
      //                     }
      //                 }
      //             });


      //             FacilityAdaptor.populateAvailableTimeslots(fcArr, dayStart);

      // fcArr.forEach(x => {
      //     x.calendarTimeslotOriginal = [];
      //     x.calenderTimeslots.forEach(val => x.calendarTimeslotOriginal.push(Object.assign({}, val)));
      // });

      //             fcArr.forEach(x=>{
      //                 x.calendarTimeslotOriginal = [];
      //                 x.calenderTimeslots.forEach(val => x.calendarTimeslotOriginal.push(Object.assign({}, val)));
      //             });


      //                 let _validationOutPut = await this.CustomFunctionOnCalanderPopulate(fcArr);
      //             }

      //             //this.facilitySummary = Object.assign({}, fcArr[0]);
      //             this.facilitySummary.timeslotLoaded = true;
      //             this.IsDateChangeFromCalendar = false;
      //         }
      //     },
      //         err => {
      //             console.log("Error", err);
      //             this.showUnavailableMessage = true;
      //         }
      //     );
      // }
    }
  }

  validateNonOperationalHours(searchStartTime: Date, searchEndTime: Date) {
    var isBookingForNonOperationalHours = false;
    if (!environment.AllowToDoBookingForNonOperationalHours) {
      let _cn = this.getSelectedConfiguration();
      if (_cn) {
        if (_cn.isSystemOverride) {
          if(_cn.previousTeardownTime && _cn.previousTeardownTime > 0){
            searchEndTime = new Date(new Date(searchEndTime).getTime() + _cn.previousTeardownTime * 60000);

            let maxEndTime = new Date(this.endTime);
            maxEndTime.setHours(24, 0, 0)
            if (Utility.convertToISO(searchEndTime) == Utility.convertToISO(maxEndTime)) {
              searchEndTime = new Date((new Date(this.endTime)).setHours(23, 59, 0, 0))
            }
          }
        }
      }

      const { openingTime, closingTime } = FacilityAdaptor.getOpeningClosingTimes(this.facilitySummary, this.startTime);
      this.facilityOpeningTime = openingTime.toString();
      this.facilityClosingTime = closingTime.toString();
      if (this.facilitySummary.openingTime) {
        let _openingTime = Utility.changeDatePart(Utility.convertISOToDate(openingTime), Utility.convertISOToDate(this.getFormattedDate(this.startTime)));
        if (searchStartTime < _openingTime && searchStartTime.toTimeString() != _openingTime.toTimeString()) {
          this.showUnavailableOperationalMessage = true;
          this.isAvailable = false;
          isBookingForNonOperationalHours = true;
          // return;
        }
      }
      if (this.facilitySummary.closingTime) {
        let _closingTime = Utility.changeDatePart(Utility.convertISOToDate(closingTime), Utility.convertISOToDate(this.getFormattedDate(this.endTime)));
        if (searchEndTime > _closingTime && searchEndTime.toTimeString() != _closingTime.toTimeString()) {
          this.showUnavailableOperationalMessage = true;
          isBookingForNonOperationalHours = true
          this.isAvailable = false;
          //  return;
        }
      }
    }
    if (!isBookingForNonOperationalHours)
      this.showUnavailableOperationalMessage = false;

    return isBookingForNonOperationalHours;
  }

  getFormattedDate(selected: Date) {
    let searchabledate = new Date(this.date.year(), this.date.month(), this.date.date());
    if (selected)
      searchabledate.setHours(selected.getHours(), selected.getMinutes(), selected.getSeconds());
    return Utility.convertToISO(searchabledate);
  }

  attendeesChanged(val) {
    if (new String(val).length > 5) {
      val = +String(val).slice(0, 5);
    }
  }

  displayBumpIn(date: Date) {
    let tempDate = new Date(date);
    tempDate.setMinutes(tempDate.getMinutes() - this.facilitySummary.configuration.setupTime)
    return tempDate
  }

  displayBumpOut(date: Date) {
    let tempDate = new Date(date);
    tempDate.setMinutes(tempDate.getMinutes() + this.facilitySummary.configuration.teardownTime)
    return tempDate
  }


  async addBooking(action: string) {


    if (this.isBookable()) {


      this.isBookingAdded = true;
      this.facilitySummary.startTime = this.getFormattedDate(this.startTime);
      this.facilitySummary.endTime = this.getFormattedDate(this.endTime);
      this.facilitySummary.attendees = (this.attendees == null || isNaN(this.attendees) || this.attendees == 0) ? 1 : this.attendees;

      if (this.facilitySummary.selectedItem != undefined) {
        FacilityAdaptor.changeFacilityItem(this.facilitySummary, this.facilitySummary.selectedItem, this.facilitySummary.selectedConfiguration);
      } else if (this.facilitySummary.selectedConfiguration) {
        this.facilitySummary.configuration = this.facilitySummary.selectedConfiguration;
      }
      //this.facilitySummary.configuration = FacilityAdaptor.getConfiguration(this.facilitySummary.item, this.facilitySummary);


      //validateOnAddToBooking

      let _validationOutPut;


      if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
        let exsitingfacilitySummaries = (this.cartData.addedFacilites ?? [])
          .filter(f => f !== this.facilitySummary);
        _validationOutPut = await this.CallCustomFunction(this.facilitySummary, Action.OnAddItemToBooking, this.getPackageDetail(), exsitingfacilitySummaries)
      }
      if (!_validationOutPut || (_validationOutPut && _validationOutPut.ContinueProcess) ) {
        const filter = this.getPackageFilter();
        if (this.selectedPackageDetail) {
          filter.PackageDetail = this.selectedPackageDetail;
          if (filter.BussinessAreaId == null || filter.BussinessAreaId === undefined || (typeof filter.BussinessAreaId === 'number' && isNaN(filter.BussinessAreaId))) {
            filter.BussinessAreaId = this.selectedPackageDetail.businessAreaId;
          }
        }
        this.store.dispatch(new UpdateBookingPackage(filter));
        //action 0:Add More Venues;  1: Book Now
        if (action == "0") {
          let _deepClonefcs = _.cloneDeep(this.facilitySummary);
          this.store.dispatch(new AddFacility(_deepClonefcs, action));
        } else if (action == "1") {
          this.store.dispatch(new AddFacility(this.facilitySummary, action));
        }
        for (const fc of this.facilitySummaries ?? []) {
          this.calculateItemPrices([fc], fc.startTime, fc.endTime);
        }


        var n = 0;
        //setTimeout(() => {
        //    n = n + 10;
        //    this.isBookingAdded = false;
        //    this.dialogRef.close(this.facilitySummary);
        //}, 2000);

        if (action == "0") {
          this.snackBar.openFromComponent(SuccessMessageComponent, {
            data: "Cart updated successfully with " + this.facilitySummary.name + ".",
            duration: 5000,
            verticalPosition: 'top',
          });
          // setTimeout(() => {
          //   n = n + 10;
          //   this.isBookingAdded = false;
          //   this.dialogRef.close();
          // }, 2000);
        }
        setTimeout(() => {
          n = n + 10;
          this.isBookingAdded = false;
          this.updateQuestionPopupState();
          //action 0:Add More Venues;  1: Book Now
          this.dialogRef.close(action);

        }, 2000);
      }

    }
    return;
  }

  //#region time picker

  initializeTime(): void {
    this.minStartDate = Utility.roundToMinDuration(new Date(), environment.MinimumBookingDuration).newDate;
    this.maxStartDate = new Date();
    this.maxStartDate.setHours(24, 0, 0);
    this.maxStartDate = moment(this.maxStartDate).add(environment.MinimumBookingDuration * -1, 'm').toDate();

    this.minEndDate = moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate();
    this.maxEndDate = new Date();
    this.maxEndDate.setHours(24, 0, 0);
    this.dateChanged();
  }

  async dateChanged() {

    this.showBookingLeadDayValidationMessage = false;
    this.showUnavailableFutureDateMessage = false;
    this.isAvailable = false;
    this.showUnavailableMessage = false;
    this.IsDateChangeFromCalendar = true;
    this.startTime = Utility.changeDatePart(this.startTime, this.date.toDate());
    var dt = this.date.toDate();
    var today = new Date();


    if (!(dt.getFullYear() == today.getFullYear() && dt.getMonth() == today.getMonth() && dt.getDate() == today.getDate())) {
      dt.setHours(0, 0, 0);
      this.minStartDate = dt;
    } else {
      if (new Date(this.startTime) < new Date()) {
        this.startTime = Utility.roundToMinDuration(new Date(), environment.MinimumBookingDuration).newDate;
      } else {
        let newStartTime = Utility.roundToMinDuration(new Date(), environment.MinimumBookingDuration).newDate;
        if (this.startTime) {
          newStartTime.setHours(this.startTime.getHours());
          newStartTime.setMinutes(this.startTime.getMinutes());
          this.startTime = newStartTime;
        }
      }
      this.minStartDate = Utility.roundToMinDuration(new Date(), environment.MinimumBookingDuration).newDate;
    }

    this.maxStartDate = Utility.changeDatePart(new Date(this.maxStartDate), this.date.toDate());
    this.maxStartDate.setMinutes(this.maxStartDate.getMinutes() + 1);
    let newEndTime = moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate();

    if (this.endTime) {
      newEndTime.setHours(this.endTime.getHours());
      newEndTime.setMinutes(this.endTime.getMinutes());
      this.endTime = newEndTime;
    }

    this.minEndDate = new Date(moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate());
    this.maxEndDate = new Date(this.minEndDate);
    this.maxEndDate.setHours(24, 0, 0);

    var selectedDate = this.date.toDate();
    selectedDate.setHours(0, 0, 0, 0);
    var futureDate = new Date(environment.LatestFutureBookingDate);
    futureDate.setHours(0, 0, 0);

    if (selectedDate > futureDate) {
      this.showUnavailableFutureDateMessage = true;
      this.showUnavailableFutureDateErrorMessage = environment.LatestFutureBookingDateErrorMessage.replace("#FacilityName#", this.facilitySummary.name);
      this.showUnavailableFutureDateErrorMessage = this.showUnavailableFutureDateErrorMessage.replace("#LatestFutureBookingDate#", moment(environment.LatestFutureBookingDate).format(environment.DateFormat.toUpperCase()).toString());
      this.isAvailable = false;
    }
    if (this.isEnableAutoAvailabilityCheck) this.checkAvailability();

    if (this.cartData && this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      let _validationOutPut = await this.CallCustomFunction(this.facilitySummary, Action.OnBookingItemDateChange, this.getPackageDetail());
      const tempFacilitySummary: FacilitySummary[] = [];
      this.facilitySummary.availableTimeslots = [];
      tempFacilitySummary.push(this.facilitySummary);
      FacilityAdaptor.populateAvailableTimeslots(tempFacilitySummary, selectedDate);
    }

    this.changetimeline();

    this.itemUnavailableMessages = !this.isItemAvailable ? "This item is not available for the selected Date" : undefined;

  }

  changetimeline() {
    let fcArr = [];
    fcArr.push(this.facilitySummary);

    if (this.IsDateChangeFromCalendar) {
      let dayStart = new Date(this.startTime);
      dayStart.setHours(0);
      dayStart.setMinutes(0);
      dayStart.setSeconds(0);

      let dayEnd = new Date(this.startTime);
      dayEnd.setHours(23);
      dayEnd.setMinutes(59);
      dayEnd.setSeconds(0);

      this._bookingService.checkDiaryNote(dayStart, dayEnd, ({ hasUnavailableDilivaryNote, diaryNoteTimeSlot, unavailableVenueIds }) => {
        let availablityTimeSlotResult = this._assetService.timeslotSearch(this.facilitySummary.id, this.getFormattedDate(dayStart), this.getFormattedDate(dayEnd));
        availablityTimeSlotResult.subscribe(async res => {
          this.facilitySummary.availableTimeslots = [];
          this.facilitySummary.calenderTimeslots = [];
          this.facilitySummary.timeslotLoaded = false;
          //validate on date change

          if (this.isEnableTimeLineAdvancedMode)
            this.drawSelectedTimeline();
          if (res) {

            res.forEach(t => {
              if (t.asset.id) {
                var facility = fcArr.find(f => f.id == t.asset.id);
                if (facility) {
                  if (!facility.calenderTimeslots) facility.calenderTimeslots = [];
                  facility.timeslotLoaded = true;
                  var arr: Timeslot[] = [];
                  arr.push(t);
                  var ts;
                  if (unavailableVenueIds.length > 0 && unavailableVenueIds?.includes(facility?.venue?.id)) {
                    ts = FacilityAdaptor.populateTimeslot(
                      (diaryNoteTimeSlot),
                      this.date.toDate(),
                      facility);
                    this.hasDiaryNote = hasUnavailableDilivaryNote;
                    this.isAvailable = hasUnavailableDilivaryNote ? false : true;
                  } else {
                    this.hasDiaryNote = false
                    ts = FacilityAdaptor.populateTimeslot(
                      (arr),
                      this.date.toDate(),
                      facility);
                  }
                  if (ts) {
                    ts.forEach(x => {
                      facility.calenderTimeslots.push(x);
                    });
                  }
                }
              }
            });
            fcArr.forEach(facility => {
              if (hasUnavailableDilivaryNote && unavailableVenueIds.includes(facility?.venue?.id)) {
                facility.hasDiaryNote = true;
                this.hasDiaryNote = hasUnavailableDilivaryNote;
                this.isAvailable = false;
                var ts = FacilityAdaptor.populateTimeslot(
                  (diaryNoteTimeSlot),
                  this.date.toDate(),
                  facility);
                if (ts) {
                  ts.forEach(x => {
                    facility.calenderTimeslots.push(x)
                  })
                }
              } else {
                facility.hasDiaryNote = false;
                this.hasDiaryNote = false
              }
            });




            fcArr.forEach(x => {
              x.calendarTimeslotOriginal = [];
              x.calenderTimeslots.forEach(val => x.calendarTimeslotOriginal.push(Object.assign({}, val)));
            });


            if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {

              let _validationOutPut = await this.CustomFunctionOnCalanderPopulate(fcArr);
            }

            const tempFacilitySummary: FacilitySummary[] = [];
            this.facilitySummary.availableTimeslots = [];
            tempFacilitySummary.push(this.facilitySummary);
            FacilityAdaptor.populateAvailableTimeslots(tempFacilitySummary, dayStart);

            //this.facilitySummary = Object.assign({}, fcArr[0]);
            this.facilitySummary.timeslotLoaded = true;
            this.IsDateChangeFromCalendar = false;
          }
        },
          err => {
            console.log("Error", err);
            this.showUnavailableMessage = true;
          }
        );
      });


    }

  }

  startTimeChanged() {
    this.timechange = true;
    if (!this.isEnableAutoAvailabilityCheck)
      this.isAvailable = false;
    if (this.startTime != null) {
      if (this.startChangedByTimeslotClick == 0) {
        var dtObj = Utility.roundToMinDuration(this.startTime, environment.MinimumBookingDuration);
        if (dtObj.isDateChanged)
          this.startTime = moment(dtObj.newDate).toDate();
      } else {
        this.startChangedByTimeslotClick--;
      }


      this.minEndDate = moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate();

      if (moment(this.startTime) >= moment(this.endTime))
        this.endTime = moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate();

      var dt = this.date.toDate();
      var today = new Date();
      if ((dt.getFullYear() == today.getFullYear() && dt.getMonth() == today.getMonth() && dt.getDate() == today.getDate())) {
        if (this.startTime < today) {
          this.startTime = Utility.roundToMinDuration(new Date(), environment.MinimumBookingDuration).newDate;
        }
      }
      if (this.endTime.getFullYear() != this.startTime.getFullYear() ||
        this.endTime.getMonth() != this.startTime.getMonth() ||
        this.endTime.getDate() != this.startTime.getDate()) {
        this.endTime.setFullYear(this.startTime.getFullYear(), this.startTime.getMonth(), this.startTime.getDate());
      }
    }
    let startEndTime = this.getStartEndTime();
    this.validateNonOperationalHours(startEndTime.start, startEndTime.end);
    if (this.isEnableTimeLineAdvancedMode)
      this.drawSelectedTimeline();

    this.isStartTimeChanged = true;
    this.CallTimeChangeValidation();
  }

  endTimeChanged() {
    this.timechange = true;
    if (!this.isEnableAutoAvailabilityCheck)
      this.isAvailable = false;
    if (this.endTime != null) {
      if (this.endTime.getFullYear() == this.maxEndDate.getFullYear() &&
        this.endTime.getMonth() == this.maxEndDate.getMonth() &&
        this.endTime.getDate() == this.maxEndDate.getDate() &&
        this.endTime.getHours() == this.maxEndDate.getHours() &&
        this.endTime.getMinutes() == this.maxEndDate.getMinutes()) {
        this.endTime = moment(this.endTime).add(-1, 'm').toDate();
      } else {
        if (this.endChangedByTimeslotClick == 0) {
          var dtObj = Utility.roundToMinDuration(this.endTime, environment.MinimumBookingDuration, true);
          if (dtObj.isDateChanged)
            this.endTime = moment(dtObj.newDate).toDate();


        } else {
          this.endChangedByTimeslotClick--;
        }


        if (moment(this.startTime) >= moment(this.endTime))
          this.endTime = moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate();
      }
    }
    if (this.isEnableTimeLineAdvancedMode)
      this.drawSelectedTimeline();


    let startEndTime = this.getStartEndTime();
    this.validateNonOperationalHours(startEndTime.start, startEndTime.end);

    this.isStartTimeChanged = false;
    this.CallTimeChangeValidation();

    return this.endTime;
  }

  closeTimeMenu() {
    if (this.timechange) {
      if (this.isEnableAutoAvailabilityCheck) {
        this.checkAvailability();
        this.closeEndTimePopup();
      } else {
        let startEndTime = this.getStartEndTime();
        this.validateNonOperationalHours(startEndTime.start, startEndTime.end);
      }

      let itm = (this.facilitySummary.selectedItem ? this.facilitySummary.selectedItem : this.facilitySummary.item);

      // onchanging number of attendees if price typee cover
      if ((itm.itemMinPrice && itm.itemMinPrice.priceType.toLowerCase() == "covers") || (itm.itemMaxPrice && itm.itemMaxPrice.priceType.toLowerCase() == "covers")) {
        this.facilitySummary.attendees = this.attendees;
      }
      this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime));
      this.timechange = false;

    } else {
      this.closeEndTimePopup();
    }
  }

  //display recive message
  receiveConfigurationMessage(event) {

    let cnf = this.getSelectedConfiguration();
    let newCnf = this.facilitySummary.configurations.find(f => f.id == event);
    this.facilitySummary.selectedConfiguration = newCnf;
    if (cnf.setupTime != newCnf.setupTime || cnf.teardownTime != newCnf.teardownTime) {
      if (this.isEnableAutoAvailabilityCheck) {
        this.checkAvailability();
      }
      this.drawSelectedTimeline();
    }


  }

  // start time end time click event
  setStartEndTime(slot) {
    const startTimeSlot = Utility.convertISOToDate(slot.startTime);
    const endTimeSlot = Utility.convertISOToDate(slot.endTime);
    this.startChangedByTimeslotClick++;
    this.startTime = startTimeSlot;
    this.endChangedByTimeslotClick++;
    this.endTime = endTimeSlot;

    //time and date initialize
    // this.initializeTime();
    //this.isAvailable = true;
    //this.showUnavailableMessage = false;

    if (this.isEnableAutoAvailabilityCheck)

      this.checkAvailability();


  }

  openAlternativeOptions(): void {
    //console.log(facility);
    this.facilitySummary.startTime = this.getFormattedDate(this.startTime);
    this.facilitySummary.endTime = this.getFormattedDate(this.endTime);

    const dialogRef = this.dialog.open(AlternativeOptionsComponent, {
      data: { fc: this.facilitySummary },
      panelClass: ['w80modal', 'dialog-container-common'],
      width: '250px'
    });
  }

  getImagesforConfigurations() {
    let configurationWithNoImage = [];
    if (this.facilitySummary.configurations != undefined && this.facilitySummary.configurations.length > 0) {
      this.facilitySummary.configurations.forEach((c, i) => {
        let configuration = c as Configuration;
        if (configuration.configurationThumbnail == undefined && configuration.type != undefined) {
          configurationWithNoImage.push({
            id: configuration.id,
            type: configuration.type,
            configurationCategoryId: configuration.configurationCategoryId
          });
        }
      });

      if (configurationWithNoImage.length > 0) {
        let result = this._assetService.getConfigurationImages(configurationWithNoImage);
        result.safeSubscribe(this, data => {

          data.forEach((c, i) => {
            let index = this.facilitySummary.configurations.findIndex(x => x.id == c.id);
            if (index > -1)
              this.facilitySummary.configurations[index].configurationThumbnail = (c.isLocalUrl) ? environment.ApiUrl + c.url : c.url;
          });
        });
      }

    }
  }


  closeStartTimePopup() {
    this.starttrigger.closeMenu()
  }

  closeEndTimePopup() {
    this.endtrigger.closeMenu()
  }

  setAvailableSlots(slots: CalenderTimeslot[]) {
    this.availableSlots = slots;
  }

  drawSelectedTimeline() {
    let searchdate = new Date(this.date.year(), this.date.month(), this.date.date());
    let selectedStart = Utility.appendTimePart(searchdate, Utility.convertISOToDate(this.startTime), true);
    let selectedEnd = Utility.appendTimePart(searchdate, Utility.convertISOToDate(this.endTime), true);
    FacilityAdaptor.populateSelectedTimeslot(this.facilitySummary, selectedStart, selectedEnd, this.getSelectedConfiguration());
  }


  //getFaaciltyItemPriceDisplay(facilitySummary) {

  //    if (facilitySummary.item != undefined && facilitySummary.item.calculatedMinPrice != undefined) {
  //        if (facilitySummary.item.calculatedMinPrice.priceIncludingTax == facilitySummary.item.calculatedMaxPrice.priceIncludingTax) {
  //        return true;
  //    } else {
  //            return false;
  //        }
  //    }
  //    return false;
  //}

  getFacilityName(facility) {
    if (facility.name != undefined && facility.item.name != undefined) {
      if (facility.name == facility.item.name) {
        return facility.item.name;
      }
      return (facility.name + " : " + facility.item.name);
    }
  }

  getTimeslotAvailabilityHeader() {
    var checkTimeSlots = this.availableSlots.length;
    if (checkTimeSlots == 0) {
      return 'No time slots are available';
    }
    return 'Available time slots';

  }

  getBumpInOutNotification() {

    if (this.displayBumpInOutNotification) {
      //undefined check
      var configuration = (this.facilitySummary.selectedConfiguration != undefined) ? (this.facilitySummary.selectedConfiguration) : (this.facilitySummary.configuration);
      var SetupTime = (configuration && configuration.setupTime != null) ? (configuration.setupTime) : 0;
      var teardownTime = (configuration && configuration.teardownTime != null) ? (configuration.teardownTime) : 0;
      //null check
      if (SetupTime == 0 && teardownTime == 0) {
        return;
      }
      if (SetupTime == 0 || teardownTime == 0) {
        var returnDisplayBumpInOutValue = (SetupTime != 0 && teardownTime == 0) ?
          ("This venue has a setup time of " + SetupTime + " minutes")
          : (SetupTime == 0 && teardownTime != 0) ? ("This venue has a  tear down time of " + teardownTime + " minutes") : "";
        return returnDisplayBumpInOutValue;
      }
      if (SetupTime == teardownTime) {
        return ("This venue has a setup and tear down time of " + SetupTime + " minutes");
      }
      return ("This venue has a setup time of " + SetupTime + " minutes and tear down time of " + teardownTime + " minutes");

    }
    return;
  }

  isFacilityAndItemNameSame() {
    let _itemName = "";
    if (this.facilitySummary)
      if (this.getItem().name) {
        _itemName = this.getItem().name.trim();
      }
    return this.facilitySummary.name.trim() == _itemName;
    return false;
  }

  getItem() {
    if (this.facilitySummary) {
      var selectedItem = this.facilitySummary.selectedItem;
      if (selectedItem == undefined) {
        selectedItem = this.facilitySummary.item;
      }
      return selectedItem;
    }
    return;
  }

  getConfigurationData() {
    var selectedItem = this.getItem();
    if (selectedItem) {
      return FacilityAdaptor.getFacilityConfigurations(this.facilitySummary, selectedItem);
    }
  }

  getSelectedConfiguration() {
    if (this.facilitySummary) {
      return FacilityAdaptor.getAdapterSelectedConfiguration(this.facilitySummary);
    }
  }

  isBumpinOutIncluded() {
    var cnf = this.getSelectedConfiguration();
    return cnf.setupTime > 0 || cnf.teardownTime > 0
  }

  estimatedPriceRange(facility) {
    let itm = this.getItem();
    return BookingAdaptor.isRange(itm.calculatedMinPrice, itm.calculatedMaxPrice)
  }

  getEstimatedPrice(facility) {
    let itm = this.getItem();
    var prc = BookingAdaptor.getItemPrice(itm, 1);
    if (prc) {
      return prc.priceIncludingTax;
    }
  }

  isHaveEstimatedPrice(facility) {
    let price = this.getEstimatedPrice(facility);
    return (price > -1)
  }

  public attendeesIsValid() {
    try {
      var cnf = this.getSelectedConfiguration();
      if (cnf.capacity && cnf.capacity != null) {
        return (cnf.capacity >= this.attendees)
      }
    } catch (e) {
      return false;
    }
  }

  public attendeesCountIsValid() {
    try {
      return (this.attendees != null && this.attendees != 0 && (!isNaN(this.attendees)));
    } catch (e) {
      return false;
    }
  }

  isBookable() {
    return  !this.hasDiaryNote &&
      this.isAvailable &&
      this.attendeesIsValid() &&
      this.attendeesCountIsValid() &&
      !this.isBookingLeadDaysError &&
      this.isHaveEstimatedPrice(this.facilitySummary) &&
      this.isHavingValidMinTime() &&
      this.isItemAvailable &&
      !this.showUnavailableOperationalMessage &&
      !this.isSestemLoading();
  }

  showItemsAvailability(facility) {
    if (facility.items != undefined && this.isConfigurationEnabled == true) {
      if (facility.items.length > 1) {
        return true;
      }
    }
    return false;
  }

  isUnitPriceRange(item) {
    if (item == undefined) return false;

    item.itemMinPrice = (item.itemMinPrice) ? item.itemMinPrice : item.itemMaxPrice;
    item.itemMaxPrice = (item.itemMaxPrice) ? item.itemMaxPrice : item.itemMinPrice;
    if (item.itemMinPrice == undefined || item.itemMaxPrice == undefined)
      return false;

    var min = (item.itemMinPrice) ? item.itemMinPrice!.priceIncludingTax : 0;
    var max = (item.itemMaxPrice) ? item.itemMaxPrice!.priceIncludingTax : 0;

    var dp: DecimalPipe = new DecimalPipe('en');
    return dp.transform(min, '1.2-2') != dp.transform(max, '1.2-2');
  }

  async addToBookingAlternative(item) {
    this.facilitySummary.selectedItem = item;
    this.facilitySummary.item = item;
    //this.checkAvailability();
    this.facilitySummary.selectedConfiguration = FacilityAdaptor.getConfiguration(this.facilitySummary.selectedItem, this.facilitySummary);
    //this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime));
    this.checkAvailability();
    let _validationOutPut;
    if (this.cartData && this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      _validationOutPut = await this.CallCustomFunction(this.facilitySummary, Action.OnChangeItem, this.packageDetail)
      this.drawSelectedTimeline();
    }
    this.setItemRemainingLeadDaysList(this.startTime, this.facilitySummary.items)
    this.itemUnavailableMessages = !this.isItemAvailable ? "This item is not available for the selected Date" : undefined;
    this.validatePackageClass(this.cartData);
    this.filteredPackages = this.selectPackageList();
  }


  async CallCustomFunction(facilitySummary, action, packageDetails, exsitingfacilitySummaries = []) {
    let _validationOutPut;

    let _formData = {
      attendees: this.attendees,
      startTime: this.startTime,
      endTime: this.endTime,
      date: this.date,
      selectedConfiguration: this.facilitySummary.selectedConfiguration,
      configuration: this.facilitySummary.configuration,
      selectedItem: this.facilitySummary.selectedItem,
      isStartTime: this.isStartTimeChanged
    };

    let _options = {
      preliminaryAsUnavailable: this.AppData.BookingConfig.CheckAvailability.DisplayPreliminarySlotAsUnavailble
    };

    if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      let _validateFunction = this.cartData.userDefinedFunctions.find(
        x => x.customFunctionAction.action == action
      );

      if (_validateFunction && _validateFunction.functionName && window[_validateFunction.functionName]) {
        this.customFunctionActiveRequests++;
        this.loading = true;

        try {
          _validationOutPut = await window[_validateFunction.functionName](
            facilitySummary, _formData, _options, packageDetails, exsitingfacilitySummaries
          );

          this.errorMessages = [];
          this.warningMessages = [];

          if (_validationOutPut?.Messages?.length > 0) {
            _validationOutPut.Messages.forEach(er => {
              if (er.ErrorType == ErrorType.Error) {
                this.errorMessages.push(er.Detail);
              }
              if (er.ErrorType == ErrorType.Warning) {
                this.warningMessages.push(er.Detail);
              }
            });
          }

          this.continueProcess = !!(_validationOutPut && _validationOutPut.ContinueProcess);

          if (_validationOutPut) {
            this.checkAvailability(); // ✅ make sure this is awaited
          }
        } catch (err) {
          console.error("Error in CallCustomFunction:", err);
          this.continueProcess = false;
        } finally {
          this.customFunctionActiveRequests--;
          if (this.customFunctionActiveRequests <= 0) {
            this.loading = false;
          }
        }
      }
    }

    return _validationOutPut;
  }

  async CallCustomFunctionForChangePackageOnCart(facilitySummary, action, packageDetails) {
    let _validationOutPut;

    let _options = {
      facilitySummarries: this.cartData.addedFacilites
    };

    let _formData = {};

    if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      let _validateFunction = this.cartData.userDefinedFunctions.find(
        x => x.customFunctionAction.action == action
      );

      if (_validateFunction && _validateFunction.functionName && window[_validateFunction.functionName]) {
        this.cartPackageCustomFunctionActiveRequests++;
        this.loading = true;

        try {
          _validationOutPut = await window[_validateFunction.functionName](
            facilitySummary,
            _formData,
            _options,
            packageDetails
          );

          if (_validationOutPut) {
            this.checkAvailability();
          }
        } catch (err) {
          console.error("Error in CallCustomFunctionForChangePackageOnCart:", err);
        } finally {
          this.cartPackageCustomFunctionActiveRequests--;
          if (this.cartPackageCustomFunctionActiveRequests <= 0) {
            this.loading = false;
          }
        }
      }
    }

    return _validationOutPut;
  }

  async CustomFunctionOnCalanderPopulate(facilityArray) {
    let _validationOutPut;

    let _options = {

      preliminaryAsUnavailable: this.AppData.BookingConfig.CheckAvailability.DisplayPreliminarySlotAsUnavailble

    }

    let _formData = {
      attendees: this.attendees,
      startTime: this.startTime,
      endTime: this.endTime,
      date: this.date

    }

    if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      let _validateFunction = this.cartData.userDefinedFunctions.find(x => (x.customFunctionAction.action == Action.OnPopulateUnavailableCalenderSlots))

      if (_validateFunction && _validateFunction.functionName && window[_validateFunction.functionName]) {

        _validationOutPut = await window[_validateFunction.functionName](facilityArray, _options, _formData);

      }
    }

    return _validationOutPut;

  }

  packageSelectorChange(selectedPackage: BespokePackage = null, attendees?: number) {

    if (selectedPackage) {
      this.packageFilter.PackageDetail = selectedPackage;
    }
    if (this.packageFilter && this.packageFilter.PackageDetail && this.packageFilter.PackageDetail.packageItems && this.packageFilter.PackageDetail.packageItems.length > 0) {
      let resultCal = this._packageService.CalculatePackagePrices(Utility.convertToISO(Utility.convertISOToDate(this.startTime)), Utility.convertToISO(Utility.convertISOToDate(this.endTime)), this.attendees, selectedPackage.id);
      resultCal.safeSubscribe(this, (result) => {
        if (result != null) {
          let filter = this.getPackageFilter();
          if (result.packageItems) {
            filter.PackageDetail.packageItems = result.packageItems;
            if (attendees != null) {
              filter.Attendees = attendees;
            }
          }
          this.store.dispatch(new UpdateBookingPackage(filter));
        }

      },
        err => {
          console.log("Error : calculatePackagePrice ", err);
        }
      );
    } else {
      let filter = this.getPackageFilter();
      this.store.dispatch(new UpdateBookingPackage(filter));
      //this.showPackageIncludes();
    }
    this.CallPackageChangeValidation();

  }

  getPackageFilter() {
    let filter = this.packageFilter;
    filter.BussinessAreaId = +this.selectedBusinessArea;
    filter.PackageClass = this.selectedClass;
    filter.Package = +this.selectedPackage;
    //filter.PackageDetail = result.packageItems;
    //  filter.snackBar = this.snackBar;
    filter.EventName = this.defaultEventName;
    // filter.ledgerNumber = this.ledgerNumber;
    filter.StartTime = this.minDate;
    filter.EndTime = this.maxDate;
    //filter.Attendees = this.maxattendees;
    return filter;
  }

  selectPackageList() {
    let selectedFaclities = Object.assign([], this.facilitySummaries);

    if (!selectedFaclities || selectedFaclities.length == 0) {
      selectedFaclities = [this.facilitySummary];
    } else {
      selectedFaclities.push(this.facilitySummary);
    }

    let filterdPackages = [];
    let packageFilterdByClass = this.packages.filter(a => a.packageClassId == +this.selectedClass);

    if (packageFilterdByClass.length == 0) {
      this.selectedPackage = null;
      this.selectedPackageDetail = null;
      if (this.packageDetail) {
        this.packageFilter.PackageDetail = null;
        let _filter = this.getPackageFilter()
        this.store.dispatch(new UpdateBookingPackage(_filter));
      }
      this.setPackageRemainingLeadDaysList(this.startTime, filterdPackages)
      return filterdPackages;
    }

    filterdPackages = this.getfilterPackagesBySalesCategory(packageFilterdByClass, selectedFaclities);

    // if (this.packageDetail) {
    //   let _pkgs = filterdPackages.filter(x => (x.id == this.packageDetail.id));

    //   if (!_pkgs || _pkgs.length == 0) {
    //     this.packageFilter.PackageDetail = null;
    //     let _filter = this.getPackageFilter()
    //     this.store.dispatch(new UpdateBookingPackage(_filter));
    //   }
    // }
    let stillValidSelection = this.selectedPackage && this.selectedPackage != "" && filterdPackages?.some(pkg => pkg.id === this.selectedPackage);
    if(!stillValidSelection && filterdPackages.length == 1){
      this.selectedPackage = filterdPackages[0].id;
      this.packageSelectorChange(filterdPackages[0]);
      this.questionValidation();

    }else if (filterdPackages.length == 0) {
        this.selectedPackage = null;
        this.selectedPackageDetail = null;
        if (this.packageDetail) {
          this.packageFilter.PackageDetail = null;
          let _filter = this.getPackageFilter()
          this.store.dispatch(new UpdateBookingPackage(_filter));
        }
        this.setPackageRemainingLeadDaysList(this.startTime, filterdPackages)
        return filterdPackages;
      }
    this.setPackageRemainingLeadDaysList(this.startTime, filterdPackages)
    return filterdPackages;
  }


  async packageChange() {
    if (this.selectedPackage == "") {
      this.selectedPackage = null;
      this.selectedPackageDetail = null;
      this.isValidPackage = false;
      this.packageSelectorChange()
    } else {

      if (this.facilitySummaries && this.facilitySummaries.length >= (this.isAddFacility ? 0 : 1) && this.facilitySummaries.length != 0) {
        if (this.getPackageDetail() && this.getPackageDetail().id != this.selectedPackage) {
          let dialogRef = this.dialog.open(DeleteConfirmationComponent, {
            data: {
              message: 'Please note that, if you change the event it will be applied to the other facilities in the booking cart. Do you want to proceed?',
              yesText: 'YES',
              noText: 'NO'
            },
            panelClass: ['custom-dialog-container', 'w30modal'],
            height: 'auto',
            width: '30%'
          });

          const sub = dialogRef.componentInstance.onAdd.subscribe(async(data: any) => {
            if (data == true) { // yes click
              this.isValidPackage = this.packageSeletedValidation();
              if(this.cartData.addedFacilites){
                let _validationOutPut;
                if (this.cartData?.userDefinedFunctions && this.cartData?.userDefinedFunctions.length > 0) {
                  _validationOutPut = await this.CallCustomFunctionForChangePackageOnCart(undefined, Action.OnPackageChange, this.packageSelected)
                }
              }

            } else {
              let _prevSelectedPackage = this.getPackageDetail();
              this.selectedPackage = _prevSelectedPackage ? _prevSelectedPackage.id : null;
            }
            this.questionValidation();

          });
        } else {
          this.isValidPackage = this.packageSeletedValidation();
        }
      } else {
        this.isValidPackage = this.packageSeletedValidation();
        this.questionValidation();

      }
    }
    //this.showPackageIncludes();

  }


  questionValidation() {
    if (this.packageFilter.PackageDetail && this.packageFilter.PackageDetail.question && this.packageFilter.PackageDetail.question.length > 0) {
      // this.store.dispatch(new QuestionPopupShown());
      this.isShowQuestionsUpdate = true;
    } else {
      // this.store.dispatch(new QuestionPopupHidden());
      this.isShowQuestionsUpdate = false;
    }
  }


  updateQuestionPopupState() {
    if (this.isShowQuestionsUpdate) {
      this.store.dispatch(new PackageQuestionPopupShown());
    } else {
      this.store.dispatch(new PackageQuestionPopupHidden());
    }
  }


  packageSeletedValidation() {
    let selectedFaclities = Object.assign([], this.facilitySummaries);

    if (!selectedFaclities || selectedFaclities.length == 0) {
      selectedFaclities = [this.facilitySummary];
    } else {
      selectedFaclities.push(this.facilitySummary);
    }

    if (this.selectedPackage == undefined || this.selectedPackage == null) {
      this.snackBar.openFromComponent(AlertMessageComponent, {
        duration: 3000,
        verticalPosition: 'top',
        data: ["Please select the event"]
      });
      return false;
    }


    let selectedPackage = this.packages.find(p => p.id == this.selectedPackage);
    this.showPackageLevelLeadDaywarnigMessage(this.selectedPackage);
    this.checkAvailability();

    if (!this.packageSelected || this.packageSelected.id != selectedPackage.id) {
      if (this.selectedPackageDetail != null) {
        if (this.selectedPackageDetail.id == selectedPackage.id) {
          this.packageSelected = this.selectedPackageDetail;
        } else {
          this.packageSelected = selectedPackage;
        }
      } else {
        this.packageSelected = selectedPackage;
      }

    }
    let isMatch = true;

    if (selectedPackage) {
      selectedFaclities.forEach(function (fc: FacilitySummary) {
        if (isMatch) {
          let _item = fc.selectedItem != null ? fc.selectedItem : fc.item;
          let index = selectedPackage.salesCategories.findIndex(sc => _item.salesCategories.findIndex(isc => isc.id == sc) >= 0);
          if (!(index != undefined && index >= 0)) {
            isMatch = false;
          }
        }
      });
      if (!isMatch) {
        this.snackBar.openFromComponent(AlertMessageComponent, {
          duration: 3000,
          verticalPosition: 'top',
          data: ["Selected event is not matched with selected facilities"]
        });
      } else {

        if (this.selectedPackageDetail == null) {
          this.selectedPackageDetail = this.packages.find(p => p.id == this.selectedPackage);
        }
        this.packageSelectorChange(this.packageSelected);
      }
    } else {
      this.snackBar.openFromComponent(AlertMessageComponent, {
        duration: 3000,
        verticalPosition: 'top',
        data: ["Selected event is not matched with selected facilities"]
      });
      isMatch = false;
    }

    if (this.packageSelected.originalQuestion && this.packageSelected.originalQuestion != null) {
      var appSetting = environment.AppSetting as AppSetting;
      let statusFilterRaw = appSetting?.BookingConfig?.BookingStatusForQuestions ?? "";
      let statusList = [];
      let approveStatusList = [];

      statusList = statusFilterRaw != null && statusFilterRaw != ""
        ? statusFilterRaw?.split(',').map(s => s.trim())
        : [String(environment.BookingStatus)];

      let approveStatusRaw = appSetting?.BookingConfig?.BookingStatusForImmediateBookingQuestions ?? "";
      approveStatusList = approveStatusRaw != null && approveStatusRaw != ""
        ? approveStatusRaw.split(',').map(s => s.trim())
        : [String(environment.BookingApproveStatus)];


      this.packageSelected.question = this.packageSelected.originalQuestion
        .filter(pq =>statusList?.includes(pq.bookingStatusId) ||
          (this.isAllImmediateConfirmed && approveStatusList?.includes(pq.bookingStatusId)));

      if(this.packageSelected?.question && this.packageSelected?.question?.length > 0){
        this.packageSelected.question.sort((a, b) => (a?.questionNo ?? 0) - (b?.questionNo ?? 0));
      }
      if (this.packageSelected.question.length > 0 && isMatch && this.answeredCurrentCount(this.packageSelected.question) == this.packageSelected.question.length) {
        this.packageFilter.PackageDetail = this.packageSelected;
      }
    }

    return isMatch;
  }

  isHavingValidMinTime() {
    let status = true;
    if (this.isCategoryAndEventEnabled) {
      if (this.isCategoryAndEventMandatory) {
        if ((+(this.selectedPackage ? this.selectedPackage : 0)) > 0) {
          status = true;
        } else {
          status = false;
        }

      } else {
        status = true;
      }
    } else {
      status = true;
    }

    if (!this.isContinueProcessOnpackageChange && !this.errorMessages) {
      status = false;
    }

    if (!this.isContinueProcessOnTimeChange && !this.errorMessages) {
      status = false;
    }

    return status;
  }

  async CallPackageChangeValidation() {
    let _validationOutPut;
    if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      _validationOutPut = await this.CallCustomFunction(this.facilitySummary, Action.OnPackageChange, this.getPackageDetail())
      this.drawSelectedTimeline();
    }

    if (_validationOutPut && _validationOutPut.ContinueProcess == false) {
      this.isContinueProcessOnpackageChange = false;
    } else {
      this.isContinueProcessOnpackageChange = true;
      this.filteredPackages = this.selectPackageList();
    }
  }

  getPackageDetail() {
    return this.packageFilter?.Package > 0 ? this.packageFilter?.PackageDetail : undefined;
  }

  async CallTimeChangeValidation() {
    let _validationOutPut;
    if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      _validationOutPut = await this.CallCustomFunction(this.facilitySummary, Action.OnTimeChange, this.getPackageDetail())
    }

    if (_validationOutPut && _validationOutPut.ContinueProcess == false) {
      this.isContinueProcessOnTimeChange = false;
    } else {
      this.isContinueProcessOnTimeChange = true;
    }
  }

  validatePackageClass(state) {
    let matchingPackages = FacilityAdaptor.getMatchedPackages([this.facilitySummary], state.bespokePackages);
    if (state.packageFilter !== undefined && state.packageFilter != null) {
      if (matchingPackages.length > 0) {

        let distinctPC = matchingPackages.map(p => p.packageClassId).filter((age, index, arr) => arr.indexOf(age) == index);
        state.packageFilter.FilteredPackageClasses = environment.PackageClasses.filter(cls => cls.Id != "0" && distinctPC.indexOf(cls.Id) >= 0);
        if (!state.packageFilter.Package || matchingPackages.findIndex(selectedP => selectedP.id == state.packageFilter.Package) < 0) {
          let currentClass = state?.packageFilter?.PackageClass ?? "";
          let classExistsInMatching = currentClass != "" && matchingPackages.some(pkg => pkg.packageClassId === currentClass);
          state.packageFilter.PackageClass = classExistsInMatching ? currentClass : matchingPackages[0].packageClassId;

          let currentBAId = state?.packageFilter?.BussinessAreaId ?? "";
          let BAIdExistsInMatching = currentBAId != "" && matchingPackages.some(pkg => pkg.businessAreaId === currentBAId);
          state.packageFilter.BussinessAreaId = BAIdExistsInMatching ? currentBAId : matchingPackages[0].businessAreaId;
        }
      } else {
        state.packageFilter.Package = 0;
      }
    }


  }


  answeredCurrentCount(question) {
    var count = 0;
    for (var q of question) {
      if ((q.type == "textQuestion" || q.type == "booleanQuestion" || q.type == "singleChoiceQuestion") && (q.answeredText != undefined && q.answeredText != null && q.answeredText != "")) {
        count++;
      } else if (q.type == "multipleChoiceQuestion") {
        var answeredCount = 0;
        if (q.answerChoices) {
          q.answerChoices.forEach((answ, indx) => {
            if (q.quantityRequired) {
              if (answ.Quantity) answeredCount++;
            } else {
              if (answ.isSelectedAnswer) answeredCount++;
            }
          });
          if (answeredCount > 0) count++;
        }
      }
    }
    return (question.length) - count;
  }


  getfilterPackagesBySalesCategory(packages: BespokePackage[], selectedFaclities: FacilitySummary[]) {
    let filterdPackages = [];
    if (packages.length) {
      packages.forEach(function (pk) {
        let isMatch = true;
        selectedFaclities.forEach(function (fc) {
          if (isMatch) {
            if (pk.salesCategories != undefined) {
              let _item;
              // high priority for selected item in absence of selected item itme is chosen
              if (fc.selectedItem) {
                _item = fc.selectedItem;
              } else if (fc.item) {
                _item = fc.item;
              }

              var index = pk.salesCategories.findIndex(sc => _item && _item.salesCategories && _item.salesCategories.length > 0 && _item.salesCategories.findIndex(isc => isc.id == sc) >= 0);
              if (!(index != undefined && index >= 0)) {
                isMatch = false;
              }
            } else isMatch = false;
          }
        });
        if (isMatch) {
          filterdPackages.push(pk);
        }
      });
    }


    return filterdPackages;
  }

  isPackageSelected() {
    return (this.selectedPackage == undefined || this.selectedPackage == null) ? false : true;
  }

  get isItemAvailable() {

    let isAvailable = true;
    // high priority for selected item in absence of selected item itme is chosen
    if (this.facilitySummary) {
      let _item = this.facilitySummary.selectedItem ?
        this.facilitySummary.selectedItem : this.facilitySummary.item ?
          this.facilitySummary.item : null
      if (_item) {
        isAvailable = (_item.availableTo && new Date(_item.availableTo) < new Date(this.endTime)) ? false : true;
      }

    }
    return isAvailable;
  }

  setLeadDaysIntoCalander(leadDays: number, freshLoad: boolean = false) {
    if (environment.DisableDatePickerForLeadDays) {
      var currentDate = new Date();
      if (leadDays < 1) {
        const minutes = leadDays * (60 * 24);
        currentDate = new Date(currentDate.getTime() + minutes * 60 * 1000);
        currentDate = moment(currentDate)
          .add(environment.MinimumBookingDuration, 'm')
          .toDate();
      } else {
        currentDate.setDate(currentDate.getDate() + leadDays);
      }
      this.minDate = currentDate;

      const minDateMoment = moment(this.minDate);

      if (this.date.isBefore(minDateMoment) && freshLoad && this.isAddFacility) {
        const combinedDateTime = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          currentDate?.getHours() || 0,
          currentDate?.getMinutes() || 0,
          currentDate?.getSeconds() || 0,
          currentDate?.getMilliseconds() || 0
        );
        this.date = moment(combinedDateTime);
        this.startTime = combinedDateTime;
        this.initializeTime();
      }
    }
  }

  setItemRemainingLeadDaysList(selectedDate: Date, items: Item[] = []) {
    this.remainingLeadDaysList = [];
    let currentTimewithMilliseconds = moment();
    let current = moment().startOf('day');
    let daysCount = moment(selectedDate).diff(current, 'days');
    if(daysCount == 0) {
      daysCount = moment(selectedDate).diff(currentTimewithMilliseconds, 'milliseconds') / (24 * 60 * 60 * 1000);
    }
    items.forEach(item => {
      let remainingLeadDays = 0;
      if (daysCount <= item.leadDays) {
        remainingLeadDays = item.leadDays - daysCount;
      }
      this.remainingLeadDaysList.push({ id: item.id, remainingLeadDays });
    });
  }

  setPackageRemainingLeadDaysList(selectedDate: Date, packages: BespokePackage[]) {
    this.remainingPackageLeadDaysList = [];
    let currentTimewithMilliseconds = moment();
    let current = moment().startOf('day');
    let daysCount = moment(selectedDate).diff(current, 'days');
    if(daysCount == 0) {
      daysCount = moment(selectedDate).diff(currentTimewithMilliseconds, 'milliseconds') / (24 * 60 * 60 * 1000);
    }
    packages.forEach(pkg => {
      let remainingLeadDays = 0;
      if (daysCount <= pkg.leadDays) {
        remainingLeadDays = pkg.leadDays - daysCount;
      }
      this.remainingPackageLeadDaysList.push({ id: pkg.id, remainingLeadDays });
    });
  }

  checkRemainingLeadDaysCount(itemId: string = null, packageId: string = null): boolean {
    if (itemId != null && packageId != null) {
      const itemMatchingEntry = this.remainingLeadDaysList.find(entry => entry.id === itemId);
      const packageMatchingEntry = this.remainingPackageLeadDaysList.find(entry => entry.id === packageId);
      return (
        (itemMatchingEntry ? itemMatchingEntry.remainingLeadDays === 0 : false) &&
        (packageMatchingEntry ? packageMatchingEntry.remainingLeadDays === 0 : false)
      );
    }
    if (itemId != null) {
      const matchingEntry = this.remainingLeadDaysList.find(entry => entry.id === itemId);
      return matchingEntry ? matchingEntry.remainingLeadDays === 0 : false;
    }
    if (packageId != null) {
      const matchingEntry = this.remainingPackageLeadDaysList.find(entry => entry.id === packageId);
      return matchingEntry ? matchingEntry.remainingLeadDays == 0 : false;
    }
    return false;
  }

  getLeadDays(selectedPackageID: string = ""): number {
    var leadDays = 0;
    var itemSetupLeadDays = 0;
    var packageSetupLeadDays = 0;
    var xmlSetupleadDays = (environment.LeadDaysForBooking == null) ? 0 : environment.LeadDaysForBooking;
    itemSetupLeadDays = this.facilitySummary?.selectedItem ? this.facilitySummary?.selectedItem.leadDays : this.facilitySummary.item.leadDays;
    if (selectedPackageID != "") {
      let selectedPackage = this.packages.find(p => p.id == selectedPackageID);
      if (selectedPackage != null) {
        packageSetupLeadDays = selectedPackage?.leadDays ?? 0;
      }
    }

    if (itemSetupLeadDays !== 0 && packageSetupLeadDays !== 0) {
      leadDays = Math.max(itemSetupLeadDays, packageSetupLeadDays);
    } else if (itemSetupLeadDays !== 0 || packageSetupLeadDays !== 0) {
      leadDays = itemSetupLeadDays || packageSetupLeadDays;
    } else {
      leadDays = xmlSetupleadDays;
    }
    return leadDays;
  }

  showPackageLevelLeadDaywarnigMessage(selectedPackageID: string = "") {
    var leadDays = this.getLeadDays(selectedPackageID);
    var isSetupPackageLevelLeadDays = false;
    this.showBookingPackageLevelLeadDayValidationMessage = false;
    let selectedPackage;
    if (selectedPackageID != "") {
      selectedPackage = this.packages.find(p => p.id == selectedPackageID);
      if (selectedPackage != null) {
        if (selectedPackage?.leadDays != undefined) {
          isSetupPackageLevelLeadDays = true;
        }
      }
    }
    this.setLeadDaysIntoCalander(leadDays);

    if (!this.checkRemainingLeadDaysCount(null, this.selectedPackage ?? null) && isSetupPackageLevelLeadDays) {
      this.bookingPackageLevelLeadDayValidationMessage =
        (environment?.BookingPackageLevelLeadDayValidationMessage ?? "")
          .replace("#LeadDays#", (Utility.getLeadTimeAsSetup(leadDays)).toString())
      this.showBookingPackageLevelLeadDayValidationMessage = true;
      this.isAvailable = false;
      this.isBookingLeadDaysError = true;
      this.showBookingLeadDayValidationMessage = false;
      return;
    }
  }


  getSetupLeadTime(leadTime) {
    return Utility.getLeadTimeAsSetup(leadTime);
  }

  getSystemGenarerateUpsellErrorMessages() {
    let errorMessege = ""
    if(this.facilitySummary?.upsellSummaries && this.facilitySummary?.upsellSummaries.length > 0) {
      this.facilitySummary?.upsellSummaries.forEach(upsell => {
        if(upsell.isSystemGenerated){
          errorMessege = "The selected time slot is unavailable as cleaning needs a 3-hour window. Please try a different time";
        }
      })
    }
    return errorMessege;
  }

  isSestemLoading() : boolean{
    return this.loading || this.availableSlotsLoading || !this.isItemPricesLoaded;
  }
}
